module.exports = __webpack_public_path__ + "static/media/CClogo.de0698bc.png";